/* A local presentation counter only; it does not track or report actual visitors. */
(() => {
  const root = document.querySelector('[data-collagax-live-activity]');
  if (!root) return;

  // Morocco-time visitor curve, shared with social-proof.js. Keep both copies identical so the
  // homepage total always equals the sum of the product-page counts at the same moment.
  // [start minute, end minute, lowest count, highest count] in Africa/Casablanca time.
  const MOROCCO_SLOTS = [
    [0, 180, 10, 15],
    [180, 300, 8, 9],
    [300, 540, 5, 6],
    [540, 840, 15, 20],
    [840, 1080, 25, 35],
    [1080, 1200, 40, 65],
    [1200, 1380, 70, 80],
    [1380, 1440, 40, 70],
  ];
  const moroccoMinutes = (date) => {
    try {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Africa/Casablanca',
        hourCycle: 'h23',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      }).formatToParts(date);
      const part = (type) => Number(parts.find((entry) => entry.type === type)?.value);
      const minutes = (part('hour') % 24) * 60 + part('minute') + (part('second') + date.getMilliseconds() / 1000) / 60;
      if (Number.isFinite(minutes)) return minutes;
    } catch {}
    // Fallback to Morocco's standard UTC+1 offset when the time zone is unavailable.
    return ((date.getUTCHours() + 1) % 24) * 60 + date.getUTCMinutes() + (date.getUTCSeconds() + date.getUTCMilliseconds() / 1000) / 60;
  };
  const moroccoSlot = (minutes) =>
    Math.max(0, MOROCCO_SLOTS.findIndex(([start, end]) => minutes >= start && minutes < end));
  const hash = (seed) => {
    let h = Math.imul(seed ^ 0x5bd1e995, 0x27d4eb2d);
    h ^= h >>> 15;
    h = Math.imul(h, 0x85ebca6b);
    h ^= h >>> 13;
    return (h >>> 0) / 4294967296;
  };
  // Deterministic smooth noise in [0, 1): identical for every visitor at the same instant.
  const smoothNoise = (minutes, span, channel) => {
    const position = minutes / span;
    const knot = Math.floor(position);
    const t = position - knot;
    const from = hash(knot * 31 + channel);
    return from + (hash((knot + 1) * 31 + channel) - from) * t * t * (3 - 2 * t);
  };
  // Closest count a slot shares with a neighbouring slot, so boundary jumps stay as small as possible.
  const meetingPoint = (low, high, otherLow, otherHigh) =>
    otherHigh < low ? low : otherLow > high ? high : Math.round((Math.max(low, otherLow) + Math.min(high, otherHigh)) / 2);
  const moroccoVisitorTotal = (date) => {
    const minutes = moroccoMinutes(date);
    const index = moroccoSlot(minutes);
    const [start, end, low, high] = MOROCCO_SLOTS[index];
    const [, , previousLow, previousHigh] = MOROCCO_SLOTS[(index + MOROCCO_SLOTS.length - 1) % MOROCCO_SLOTS.length];
    const [, , nextLow, nextHigh] = MOROCCO_SLOTS[(index + 1) % MOROCCO_SLOTS.length];
    const ramp = Math.min(30, (end - start) / 4);
    let value = low + smoothNoise(date.getTime() / 60000, 4, 1) * (high - low);
    value += (meetingPoint(low, high, previousLow, previousHigh) - value) * Math.max(0, 1 - (minutes - start) / ramp);
    value += (meetingPoint(low, high, nextLow, nextHigh) - value) * Math.max(0, 1 - (end - minutes) / ramp);
    return Math.min(high, Math.max(low, Math.round(value)));
  };
  const msUntilNextSlot = (date) => {
    const minutes = moroccoMinutes(date);
    return Math.max(0, (MOROCCO_SLOTS[moroccoSlot(minutes)][1] - minutes) * 60000) + 250;
  };

  const countElement = root.querySelector('[data-activity-count]');
  const randomBetween = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
  let count = moroccoVisitorTotal(new Date());

  const updateCount = () => {
    const now = new Date();
    const next = moroccoVisitorTotal(now);
    if (next !== count) {
      count = next;
      countElement.textContent = String(count);
      countElement.classList.remove('is-updating');
      window.requestAnimationFrame(() => countElement.classList.add('is-updating'));
      window.setTimeout(() => countElement.classList.remove('is-updating'), 400);
    }
    // Keep the 10–20 second cadence, but refresh right at a slot change so the count never lags outside its range.
    window.setTimeout(updateCount, Math.min(randomBetween(10000, 20000), msUntilNextSlot(now)));
  };

  countElement.textContent = String(count);
  window.setTimeout(updateCount, Math.min(randomBetween(10000, 20000), msUntilNextSlot(new Date())));
})();
